import {MenuItem} from '@mui/material';
import React, {forwardRef} from 'react';

/**
 * A Menu link component for the NavBar
 */
const MenuLink = forwardRef((props, ref) => (
  <MenuItem
    ref={ref}
    component="a"
    target="_blank"
    rel="noreferrer noopener"
    {...props}
  />
));

export default MenuLink;
